import { pastChallengesIds } from "@artists/challenges-testkit"
import { Button, Stack } from "@mui/material"
import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { Root } from "../../../../utils"
import type { TPagination } from "../../../@shared/pagination"
import { Pagination } from "../../../@shared/pagination"

interface Props {
	pagination: TPagination
}

export const Footer: FC<Props> = ({ pagination }) => {
	const { t } = useTranslation("past")

	return (
		<Stack alignItems='center' gap={5} mt={11}>
			<Pagination pagination={pagination} />

			<Button
				to={Root.path}
				size='large'
				component={Link}
				variant='outlined'
				data-testid={pastChallengesIds.homeBtn}
				sx={{ alignSelf: "center" }}
			>
				{t`challenges`}
			</Button>
		</Stack>
	)
}
